import { AssistantMessageDto, BaseToolInvocation, HumanAssistantMessageDto } from '@endion/types';
import { AssistantChatLoadingIndicator } from '../common/assistant-chat-loading-indicator';
import { DynamicMessageComponent } from '../dynamic-message-component';
import { MessageContent } from './message-content';

export function AiMessage({
  message,
  isLoading,
}: {
  message: AssistantMessageDto | HumanAssistantMessageDto;
  isLoading: boolean;
}) {
  if (isLoading && !message.content) return <AssistantChatLoadingIndicator shouldRender={true} />;
  return (
    <>
      <MessageContent role={message.role} content={message.content} />
      {'toolInvocations' in message
        ? (message.toolInvocations || []).map((toolInvocation: BaseToolInvocation) => (
            <DynamicMessageComponent
              key={toolInvocation.toolCallId}
              toolInvocation={toolInvocation}
              message={message}
            />
          ))
        : null}
    </>
  );
}
